var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMabDropOpen2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#58F2A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6885 19.9C13.9685 18.7933 14.9752 17.8867 15.7085 17.18C16.4552 16.46 17.0752 15.7133 17.5685 14.94C18.0618 14.1667 18.3085 13.3933 18.3085 12.62C18.3085 11.82 18.1152 11.1933 17.7285 10.74C17.3552 10.2867 16.7618 10.06 15.9485 10.06C15.1618 10.06 14.5485 10.3133 14.1085 10.82C13.6818 11.3133 13.4552 11.98 13.4285 12.82H11.2285C11.2685 11.3 11.7218 10.14 12.5885 9.34C13.4685 8.52667 14.5818 8.12 15.9285 8.12C17.3818 8.12 18.5152 8.52 19.3285 9.32C20.1552 10.12 20.5685 11.1867 20.5685 12.52C20.5685 13.48 20.3218 14.4067 19.8285 15.3C19.3485 16.18 18.7685 16.9733 18.0885 17.68C17.4218 18.3733 16.5685 19.18 15.5285 20.1L14.6285 20.9H20.9685V22.8H11.2485V21.14L12.6885 19.9Z",
    fill: "#020202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMabDropOpen2);
export default __webpack_public_path__ + "static/media/mab-drop-open-2.0fcd03269926cc8b7a20155303ee65c5.svg";
export { ForwardRef as ReactComponent };